module.exports = __webpack_public_path__ + "fonts/c690ee08a2666320fb2a12ad1a46bc6e.svg";